export const GroupNameTooltip = () => <>Bayer AzureAD group name.</>;
